import React from 'react';

const ProLabel = (props) => <div className="pro-label">Pro</div>;

export default ProLabel;
